<div class="flex flex-col gap-8">
  @for (step of steps; track step.n) {
    <section class="flex flex-col gap-4">
      <story-step [n]="step.n" [title]="step.title" [question]="step.question" />

      @if (step.n === 1) {
        <portfolio-kpis />
      }

      @if (step.n === 5) {
        <facilities-table />
      }

      <!-- Los pasos 2 a 4 llegan en LEN-2664. -->
    </section>
  }
</div>
